import QueryString from "query-string";

import {
  isCordovaApp,
  isOnline,
  cordovaFetchBooksAndChapters,
  cordovaFetchChapter,
  cordovaFetchBibles,
  cordovaFetchBible
} from "../utils/cordovaUtils";

// NEW offline bible data source
import { bibleSource, success } from "../storage";

// OLD bible data source
const baseURL =
  process.env.REACT_APP_BIBLE_API || "https://api.scripture.api.bible/v1/";
const headers = new Headers();

headers.append("Content-Type", "application/json");
headers.append("api-key", process.env.REACT_APP_BIBLE_API_KEY);

const get = (path, { params, cache = "default" } = {}) => {
  const fullPath = baseURL + path;
  const queryString = params ? QueryString.stringify(params) : null;
  const url = queryString ? `${fullPath}?${queryString}` : fullPath;

  return fetch(url, {
    headers,
    cache
  })
    .then(response => response.json())
    .catch(error => {
      console.log("fetch failed:", error);
      throw error;
    });
};
// END old data source

export const fetchBooksAndChapters = async ({ bibleId }) => {
  if (isCordovaApp) {
    return await cordovaFetchBooksAndChapters(bibleId);
  }
  const { books, status } = await (await bibleSource()).getBooks(bibleId);
  if (!success(status)) throw new Error("books not found");
  return { data: books }; // do we want to unwrap books from the data element?
};

export const fetchChapter = async ({ bibleId, chapterId, parallels = [] }) => {
  if (isCordovaApp && (parallels.length < 1 || !isOnline())) {
    return await cordovaFetchChapter(bibleId, chapterId, parallels);
  }
  const { chapter, status } = await (await bibleSource()).getChapter(
    bibleId,
    chapterId,
    parallels
  );

  if (success(status)) return chapter;
  throw new Error("cannot get chapter", bibleId, chapterId, status, chapter);
};

export const fetchAudioChapter = ({ bibleId, chapterId }) =>
  get(`audio-bibles/${bibleId}/chapters/${chapterId}`, {
    params: { "include-timecodes": true }
    // cache: "no-store"
  })
    .then(res => res.data)
    .then(chapter => chapter);

export const fetchBibles = (ids, includeAllBibles) => {
  if (isCordovaApp) return cordovaFetchBibles(ids);
  if (includeAllBibles) {
    return get(`bibles`);
  }
  return get(`bibles`, { params: { ids: ids.join(",") } });
};

export const fetchPassage = ({ bibleId, passageId }) =>
  get(`bibles/${bibleId}/passages/${passageId}`, {
    params: {
      "content-type": "text",
      "include-verse-numbers": false,
      "include-titles": false
    }
  }).then(res => res.data);

export const search = ({ bibleId, query, offset = 0, limit = 10 }) =>
  get(
    `bibles/${bibleId}/search?query=${query}&offset=${offset}&limit=${limit}&sort=canonical&fuzziness=0`
  );

export const fetchBibleInfo = async ({ bibleId }) => {
  if (isCordovaApp) return cordovaFetchBible(bibleId).then(res => res);
  const { bible, status } = await (await bibleSource()).deepCacheBible(bibleId);
  if (!success(status)) throw new Error("bible not found");
  return bible;
};
